import React, { useMemo } from 'react';
import DetailsIcon from '_content/images/transactions/detailsIcon.png';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { getRandomNumber } from 'lib/utils';
import useTranslate from 'lib/languages/useTranslate';

const Adverts = () => {
    const translate = useTranslate('banner');
    const randomNum = useMemo(() => {
        return getRandomNumber(translate('headerTexts').length - 1);
    }, []);

    return (
        <div className="adverts-container">
            <div className="advertsInner">
                <img src={DetailsIcon} />
                <p>{translate('headerTexts')[randomNum]}</p>
            </div>
            <Link to="/more/personal">{translate('buttonText')}</Link>
        </div>
    );
};

export default Adverts;
